/* eslint-disable no-plusplus */
export const zeroToNine = values => {
  const x = values.startingNumber.toString().length
  const nines = []
  let y
  for (y = 0; y < x; y++) {
    nines.push('9')
  }
  return nines.join('').toString()
}

export const padZero = (number, length) => {
  const x = length - number.toString().length
  const finalNumber = []
  let y
  for (y = 0; y < x; y++) {
    finalNumber.push('0')
  }
  return finalNumber.join('').toString() + number.toString()
}

export const zeroPad = (num, places) => String(num).padStart(places, '0')

export function getOrdinal(num) {
  const n = Math.abs(Math.floor(num))

  if (n % 100 >= 11 && n % 100 <= 13) {
    return `${n}th`
  }

  const lastDigit = n % 10
  switch (lastDigit) {
    case 1:
      return `${n}st`
    case 2:
      return `${n}nd`
    case 3:
      return `${n}rd`
    default:
      return `${n}th`
  }
}
